import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../../store/auth/authStore";
import { USER } from "../../utils/constants";
import { getAPICustom } from "../../utils/api";
import { EncryptionHelper } from "../../utils/encryption";
import { PRIMARY } from "../../utils/colors";
import { Spinner } from "../../components/Auth/styles";
import {
  Page,
  Content,
  Heading,
  SubText,
  BackButton,
  IconWrapper,
  Nav,
} from "./styles";
import CallbackIcon from "./CallbackIcon";
import TripsLogo from "../../assets/images/trips-logo.svg";

export default function GoogleCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setB2cAuth, setLastLoginMethod, login } = useAuthStore();
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const auth = localStorage.getItem("trips_auth");
  const obj: UserAuth = auth ? JSON.parse(auth) : null;
  const merchantHash = obj?.Hash;
  const merchantCode = obj?.MerchantCode;
  const merchantName = obj?.MerchantName;
  const merchantToken = obj.Token;

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setIsLoading(false);
      setErrorMessage("Authentication token not found");
      return;
    }
    fetchUserDetail(token);
  }, []);

  const fetchUserDetail = async (access_token: string) => {
    try {
      const response = await getAPICustom(USER, null, {
        Authorization: `Bearer ${merchantToken}`,
        MerchantCode: merchantCode,
        AppName: merchantName,
        MerchantHash: merchantHash,
        B2CAuthorization: `Bearer ${access_token}`,
      });
      if (response.status === 200) {
        const decryptedData = await EncryptionHelper.decrypt(
          response?.data,
          merchantHash,
          merchantCode,
        );
        const parsedData = JSON.parse(decryptedData);
        const { WalletBalance, Email, FullName, UserId, ProfileImage } =
          parsedData;
        setB2cAuth(access_token, {
          WalletBalance,
          Email,
          FullName,
          UserId,
          ProfileImage,
        });
        setLastLoginMethod("google");
        login();
        navigate("/home");
      } else {
        setIsLoading(false);
        setErrorMessage(
          response?.data?.Message || "Failed to fetch user details",
        );
      }
    } catch (error: any) {
      setIsLoading(false);
      setErrorMessage(
        error?.data?.Message ||
          error?.message ||
          "Failed to fetch user details",
      );
    }
  };

  return (
    <Page>
      <Nav>
        <img src={TripsLogo} alt="TRIPS" height="30" />
      </Nav>
      <Content>
        <IconWrapper>
          <CallbackIcon primaryColor={PRIMARY} />
        </IconWrapper>
        <Heading>
          {isLoading
            ? "We are setting up your account...."
            : errorMessage || "Apologies, but something went wrong."}
        </Heading>
        {!isLoading && errorMessage && (
          <SubText>Please try signing in again.</SubText>
        )}
        <div>
          {isLoading ? (
            <Spinner size={64} style={{ marginTop: "24px" }} />
          ) : (
            <BackButton onClick={() => navigate("/")}>Back to home</BackButton>
          )}
        </div>
      </Content>
    </Page>
  );
}
